<ng-template #component></ng-template>
